










































import { Component, Vue, Provide, Prop, Watch } from 'vue-property-decorator';
import { timeFormat, localGet } from "@/utils";
import { collectionServiceClient } from "@/api/index";
import { UpdateMarketPaymentCodeAmountReq, CalcMarketPaymentCodeFeeReq } from "@/pbjs/xcommon/collection_pb.js";
import {  CalcMarketPaymentFeeParam } from "@/pbjs/xcommon/core_pb.js";

import { setCommon, errorMsg } from "@/utils/request";

@Component({
    name: 'warn'
})
export default class CombinationProperty extends Vue {
    @Prop() repayInfo: any;
    @Prop() ticketData: any;
    @Provide() private amount: number | null = null;
    @Provide() private orderId: any = "";
    @Provide() private paynetFee: number = 0;
    @Provide() private isUpdateAmountDone: boolean = false;
    @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
    @Provide() private marketFeeList: any = [];
    @Provide() private env: any = window.location.href

    private created() {

        // calcfeeversion   0/中台  1、调接口
        console.log(this.country)
        // console.log(this.$route.query.orderId, "mmmmmmmmmmmmmmmmmmm");
        console.log('repayinfo======>',this.repayInfo)
        console.log('ticketData======>',this.ticketData)
        this.orderId = this.$route.query.orderId;
         // OpenPayHandingFeeMethod OpenPayFeeMethod = 7; // 手续费计算方式
        // enum OpenPayHandingFeeMethod {
        //     _revMethod = 0;
        //     Rate = 1; // 比例
        //     FixedValue = 2; // 固定值
        // }
        this.paynetFee = this.repayInfo.marketpaymentList[1].openpayfeemethod ===2?this.repayInfo.marketpaymentList[1].openpayfee:0;
    }

    @Watch('amount')
    onAmountChanged(val: number | null) {
        if (this.amount) {
            this.marketFeeList = []
            this.paynetFee = this.repayInfo.marketpaymentList[1].openpayfeemethod ===1?Math.ceil(this.amount * this.repayInfo.marketpaymentList[1].feerate / 100): this.repayInfo.marketpaymentList[1].openpayfee;
        }
    }

    private feeChange (e:any) {
        // 2021-08-26  印尼非实时
        if(this.country != 'id') {
            this.amount = e.target.value

        }
    }
    private hideUpdateMarketDialog() {
        this.$emit("showDiffTypeDialog", 0);
    }

    private refreshPage() {
        this.$emit("refreshPageType", 1);
    }

    private updateMarketPaymentCodeAmount() {
        console.log(this.amount)
        this.isUpdateAmountDone = true;
        let request:any = new UpdateMarketPaymentCodeAmountReq();
        request.setCommonin(setCommon());
        request.setOrderid(""+this.orderId);
        request.setAmount(this.amount);
        request.setFee(0);
        // request.setAppname(this.repayInfo.loaninfo.appname);
        request.setAppname(this.ticketData.appname)
        collectionServiceClient.updateMarketPaymentCodeAmount(request, {}, (err: any, response:any) => {
            if (response) {
                const data: any = response.toObject();
                console.log(data, "sendms");
                if(data.commonout) {
                    if (!data.commonout || (data.commonout.code == 0)) {
                        this.$message({type: "success", message: "成功"});
                        this.hideUpdateMarketDialog();
                        this.refreshPage();
                    } else if (data.commonout.code == 102) {
                        // this.pagerCount = 0;
                        // this.resultData = [];
                    } else {
                        this.$message.error(data.commonout.errmsg);
                    }
                }else{
                    if (data.code == 0) {
                        this.$message({type: "success", message: "成功"});
                        this.hideUpdateMarketDialog();
                        this.refreshPage();
                    } else if (data.code == 102) {
                        // this.pagerCount = 0;
                        // this.resultData = [];
                    } else {
                        this.$message.error(data.errmsg);
                    }
                }

            }
            if (err) {
                errorMsg(err);
            }
            this.isUpdateAmountDone = false;
        })
    }

    private calcFee(){

        if(this.amount && this.amount > 0){
            console.log('enter calc fee------------')
            //计算服务费
            let request:any = new CalcMarketPaymentCodeFeeReq();
            let _arr: any[] = [];
            this.repayInfo.marketpaymentList.forEach((item: any) => {
                let requestAuto: any = new CalcMarketPaymentFeeParam();
                requestAuto.setPaymentname(item.paymentname)
                requestAuto.setPaymentcode(item.paymentcode)
                requestAuto.setChannelcode(item.channelcode)

                _arr.push(requestAuto);
            });
            request.setCommonin(setCommon());
            request.setOrderid(""+this.orderId);
            request.setWillrepayamount(this.amount);
            request.setMarketpaymentList(_arr)
            console.log(request)
            collectionServiceClient.calcMarketPaymentCodeFee(request, {}, (err: any, response:any) => {
                if(response){
                    const data: any = response.toObject();
                    if(data.commonout) {
                        this.marketFeeList = data.marketpaymentList
                    }else{
                        this.$message.error(data.errmsg);
                    }
                    console.log('calc response======>',data)
                }
                if (err) {
                    errorMsg(err);
                }
            })
        }

    }
}
